import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { createTheme } from '@mui/material/styles';
import { ThemeProvider } from '@emotion/react';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import EditOutlined from '@mui/icons-material/EditOutlined';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@mui/styles';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

const WhiteTextField = withStyles({
  root: {
    '& .MuiInputBase-input': {
      color: '#fff', // Text color
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#fff8', // Semi-transparent underline
    },
    '& .MuiInput-underline:hover:before': {
      borderBottomColor: '#fff', // Solid underline on hover
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#fff', // Solid underline on focus
    },
  },
})(TextField);

const Body = styled(Grid)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  paddingTop: '35px',
  paddingBottom: '120px',
  paddingLeft: '44px',
  paddingRight: '44px',
  gap: '6px',
}));

const ContentGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  gap: '6px',
}));

const EditLayer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'end',
  justifyContent: 'end',
  gap: '3px',
  color: '#ddb930',
}));

const TitleText = styled(Typography)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 'bold',
  color: '#ffffff',
  paddingRight: '10px',
}));

const EditText = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#ddb930',
}));

const SubText = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  color: '#ffffff',
  fontWeight: 'bold',
}));

const SubBtnText1 = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#c1c1c1',
}));

const SubBtnText2 = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#36899f',
}));

const SubButton = styled(Box)(({ theme }) => ({
  backgroundColor: '#ddb930',
  width: '100%',
  height: '65px',
  borderRadius: '25px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const Bottom = styled(Box)(({ theme }) => ({
  paddingTop: '15px',
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
}));

const PaywallBody = (props: any) => {
  const [subText, setSubText] = React.useState<string>(
    'I am passionated by NFT design and I would be very grateful if you can support my work! Thanks!'
  );
  const [isSubTextFocused, setIsSubTextFocused] =
    React.useState<boolean>(false);
  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Body container>
          <ContentGrid item xs={12}>
            <TitleText>👋 to my Backstage! </TitleText>
            <EditLayer
              onClick={() => {
                setIsSubTextFocused(true);
              }}
            >
              <EditOutlined sx={{ fontSize: '20px' }} />
              <EditText>Edit</EditText>
            </EditLayer>
          </ContentGrid>
          <ContentGrid item xs={12}>
            {!isSubTextFocused ? (
              <Typography
                component={'span'}
                sx={{ color: '#c1c1c1', fillRule: 'evenodd' }}
              >
                <span>{subText}</span>
                <span style={{ color: '#ddb930' }}>&nbsp;&nbsp; See more</span>
              </Typography>
            ) : (
              <WhiteTextField
                style={{ width: '100%' }}
                multiline
                autoFocus
                value={subText}
                onChange={event => setSubText(event.target.value)}
                onBlur={event => setIsSubTextFocused(false)}
              />
            )}
          </ContentGrid>
          <ContentGrid item xs={12} sx={{ paddingTop: '41px' }}>
            <SubText>Subscribe to support Jane Smith</SubText>
          </ContentGrid>
          <ContentGrid
            item
            xs={12}
            sx={{ paddingTop: '18px' }}
            onClick={props.Feed}
          >
            <SubButton sx={{ maxWidth: '1000px' }}>
              <Typography
                component={'span'}
                sx={{
                  color: '#ffffff',
                  fillRule: 'evenodd',
                  fontSize: '16px',
                  fontWeight: 'bold',
                }}
              >
                <span>0.0012 ETH</span>
                <span
                  style={{
                    color: '#ffffff',
                    position: 'relative',
                    top: '-3px',
                  }}
                >
                  /month
                </span>
              </Typography>
            </SubButton>
          </ContentGrid>
          <Bottom>
            <SubBtnText1>Current balance: </SubBtnText1>
            <SubBtnText2>&nbsp; 0.1299 &nbsp; ETH</SubBtnText2>
          </Bottom>
          <Bottom>
            <SubBtnText1>After subscribing: </SubBtnText1>
            <SubBtnText2>&nbsp; 0.1287 &nbsp; ETH</SubBtnText2>
          </Bottom>
        </Body>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default PaywallBody;
